// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D8Q4","right":"styles_right__1DHHd"};